import { ESportsApiV1, SportsModel } from '@/app/models/sports.model';
import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component } from '@angular/core';
import { environment } from '@environments/environment';

export const optionsSports: SportsModel[] = [
  {
    sport: ESportsApiV1.FOOTBALL,
    text: 'Futbol',
    selected: true,
    route: 'football',
    icon: 'futbol',
    active: true,
    tracker: 'football',
    urlIcon: environment.urlSport + 'football.png',
  },
  {
    sport: ESportsApiV1.BASKETBALL,
    text: 'Basket',
    selected: false,
    route: 'Basket/todos-los-partidos',
    icon: 'basketball',
    active: true,
    tracker: '',
    urlIcon: environment.urlSport + 'football.png',
  },
  {
    sport: ESportsApiV1.BASEBALL,
    text: 'Beisbol',
    selected: false,
    route: 'Beisbol/todos-los-partidos',
    icon: 'baseball',
    active: true,
    tracker: '',
    urlIcon: environment.urlSport + 'football.png',
  },
  {
    sport: ESportsApiV1.VOLLEYBALL,
    text: 'Voleibol',
    selected: false,
    route: 'Voleibol/todos-los-partidos',
    icon: 'volleyball',
    active: true,
    tracker: '',
    urlIcon: environment.urlSport + 'football.png',
  },
  {
    sport: ESportsApiV1.HOCKEY,
    text: 'Hockey',
    selected: false,
    route: 'Hockey/todos-los-partidos',
    icon: 'icehockey',
    active: true,
    tracker: '',
    urlIcon: environment.urlSport + 'football.png',
  },
  {
    sport: ESportsApiV1.HANDBALL,
    text: 'Balonmano',
    selected: false,
    route: 'Balonmano/todos-los-partidos',
    icon: 'handball',
    active: true,
    tracker: '',
    urlIcon: environment.urlSport + 'football.png',
  },
  {
    sport: ESportsApiV1.AMERICAN_FOOTBALL,
    text: 'Futbol Americano',
    selected: false,
    route: 'FutbolAmericano/todos-los-partidos',
    icon: 'football',
    active: true,
    tracker: '',
    urlIcon: environment.urlSport + 'football.png',
  },
  {
    sport: ESportsApiV1.GANADAZO,
    text: 'Loterías Torito',
    selected: false,
    route: 'loteriaTorito',
    icon: 'torito',
    active: true,
    tracker: '',
    urlIcon: environment.urlSport + 'football.png',
  },
].filter(Boolean);

@Component({
  selector: 'app-pre-render-sports-menu',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './pre-render-sports-menu.component.html',
  styleUrl: './pre-render-sports-menu.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PreRenderSportsMenuComponent {
  urlIMG = environment.urlIMG;

  optionsSports = optionsSports;

  generateImageUrl(sport: SportsModel): string {
    return `${this.urlIMG}sports/${sport.icon}${
      sport.selected ? '-active' : ''
    }.svg`;
  }
}
